import Recorder from '.';

export default {
  base: '/record-video-mobile',
  merge: {
    activePage: 'mobile-video-recorder'
  },
  items: [{ path: '/:messageId', component: Recorder }]
};
